import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-upload-duration',
  templateUrl: './upload-duration.component.html',
  styleUrls: ['./upload-duration.component.scss'],
})
export class UploadDurationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() dataList: any;
  @Input() estimatedTime!: number;
  @Input() translationKey!: string;
  @Input() isError!: boolean;
  public notificationMessage!: string;
  private destroy$ = new Subject<void>();

  constructor(
    private translocoService: TranslocoService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.notificationMessage = this.loadMessage();
    this.appService.languageSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.notificationMessage = this.loadMessage();
      });
  }

  ngOnChanges(): void {
    this.notificationMessage = this.loadMessage();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadMessage(): string {
    if (!this.translationKey) {
      return '';
    }
    if (this.estimatedTime) {
      return this.getTranslationMessage(
        this.estimatedTime,
        this.dataList?.length * this.estimatedTime
      );
    } else {
      return this.getTranslationMessage(
        undefined,
        undefined,
        this.isError
      );
    }
  }

  getTranslationMessage(
    estimated?: number,
    multiplier?: number,
    isError?: boolean
  ): string {
    return this.translocoService.translate(this.translationKey, {
      estimated,
      multiplier,
      isError,
    });
  }
}
